import React from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {useIsMobile} from "./Helper";

/**
 * Reusable page header for all ENIGOOTurnstiles pages.
 *
 * Left side: "ENIGOO Turnikety / [crumb1] / [crumb2] / ..."
 * Right side: children (action buttons)
 *
 * crumbs = array of { label, to? }
 *   - items with `to` render as <Link>
 *   - last item (or items without `to`) render as bold text
 *
 * Usage:
 *   <PageHeader crumbs={[{label:"Turnikety", to:"/turnstile"}, {label:"Vytvořit turniket"}]}>
 *     <TurnstileButton .../>
 *   </PageHeader>
 */
const SEP = (
    <span style={{color: "#cbd5e1", fontSize: "var(--enigoo-fs-md)", margin: "0 2px"}}>/</span>
);

const PageHeader = ({crumbs = [], children}) => {
    const isMobile = useIsMobile();
    const activeAreal = useSelector(s => s.user?.activeAreal);

    return (
        <div style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "flex-start" : "center",
            justifyContent: "space-between",
            gap: "8px",
            marginBottom: "14px",
        }}>
            {/* breadcrumb */}
            <div style={{display: "flex", alignItems: "center", flexWrap: "wrap", gap: "2px"}}>
                <Link to="/enigoo-turnstile" style={{fontSize: "var(--enigoo-fs-md)", color: "#94a3b8", fontWeight: 500, textDecoration: "none"}}>
                    Správa areálu
                </Link>

                {activeAreal?.name && (
                    <>
                        {SEP}
                        <span style={{fontSize: "var(--enigoo-fs-md)", color: "#94a3b8", fontWeight: 500}}>
                            {activeAreal.name}
                        </span>
                    </>
                )}

                {crumbs.map((crumb, i) => {
                    const isLast = i === crumbs.length - 1;
                    return (
                        <React.Fragment key={i}>
                            {SEP}
                            {crumb.to && !isLast ? (
                                <Link
                                    to={crumb.to}
                                    style={{fontSize: "var(--enigoo-fs-md)", color: "#64748b", textDecoration: "none"}}
                                >
                                    {crumb.label}
                                </Link>
                            ) : (
                                <span style={{
                                    fontSize: "var(--enigoo-fs-md)",
                                    color: "#1e293b",
                                    fontWeight: isLast ? 600 : 400,
                                }}>
                                    {crumb.label}
                                </span>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>

            {/* right-side buttons */}
            {children && (
                <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
